import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export const determineInformer = (fieldsets) => {
  let allFields = fieldsets.map((fs) => fs.fields).flat();
  return allFields.find((f) => f.informs_global) || {};
};
export const determineFilterFields = (fieldsets, filterFields) => {
  let allFields = fieldsets.map((fs) => fs.fields).flat();
  let filterFieldIds = filterFields.map((ff) => ff.field_id);
  let filtFields = allFields.filter((field) =>
    filterFieldIds.includes(field.id)
  );
  return filtFields.sort((a, b) => {
    let sortA = filterFields.find((ff) => a.id === ff.field_id).sort;
    let sortB = filterFields.find((ff) => b.id === ff.field_id).sort;
    return sortA - sortB;
  });
};

export const handleCreateForm = async (formData, container_id) => {
  return axios
    .post('/manage/forms', {
      form: { ...formData, container_id },
    })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleEditForm = async (formData, id) => {
  return axios
    .put(`/manage/forms/${id}`, formData)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const copyForm = async (formId) => {
  return axios
    .get(`/manage/forms/${formId}/copy`)
    .then((res) => {
      notify.alertSuccess('Form copy successful!');
      return res;
    })
    .catch((error) => {
      notify.alertFailure('Form failed to copy.');
      return error;
    });
};

export const destroyForm = async (formId, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/forms/${formId}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};

// Provide container info for when moving form
export const fetchContainers = async () => {
  return await axios
    .get('/manage/containers')
    .then((res) => {
      return res;
    })
    .catch((error) => {
      notify.failure('Failed to get containers info');
      console.error(error.data);
      return error;
    });
};

export const moveForm = async (formId, containerId) => {
  return axios
    .put(`/manage/forms/${formId}/move`, { container_id: containerId })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      notify.alertFailure('Form move failed...');
      console.error(error.data);
    });
};
